import React from "react";

const DIMENSIONS = [
  {
    icon: "bi-grid-1x2-fill",
    label: "Dimension 01",
    title: "Business",
    items: [
      "What does it provide?",
      "Where does it operate?",
      "Who are its customers?",
      "What businesses may need it?",
    ],
  },
  {
    icon: "bi-bookmark-check-fill",
    label: "Dimension 02",
    title: "Products",
    items: [
      "Which products are new?",
      "Which products are important?",
      "Which products are seasonal?",
      "Which products need attention?",
    ],
  },
  {
    icon: "bi-globe-americas",
    label: "Dimension 03",
    title: "Market",
    items: [
      "Which region is targeted?",
      "Which customer group is relevant?",
      "Which businesses may need the offering?",
      "What opportunities exist within SELECTEZI?",
    ],
  },
];

export default function UnderstandBeforePromoting() {
  return (
    <section className="section-py section-soft">
      <div className="container-selectezi">
        <div className="section-head">
          <span className="eyebrow-label">Analytical Precision</span>
          <h2 className="section-title">Understand Before Promoting</h2>
          <p className="section-subtitle mx-auto">
            Targeted promotion requires deep operational discovery across
            three structural dimensions.
          </p>
        </div>

        <div className="row g-4">
          {DIMENSIONS.map((dim) => (
            <div className="col-lg-4" key={dim.title}>
              <div className="dimension-card">
                <span className="icon-badge">
                  <i className={`bi ${dim.icon}`} />
                </span>
                <div className="vertical-eyebrow mt-3">{dim.label}</div>
                <div className="dimension-title">{dim.title}</div>
                <ul className="dimension-list">
                  {dim.items.map((item) => (
                    <li key={item}>
                      <i className="bi bi-check-square-fill" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="flow-banner">
          <div className="flow-left">
            <i className="bi bi-arrow-left-right" style={{ fontSize: 20 }} />
            <span>BUSINESS + PRODUCTS + MARKET &rarr; RELEVANT PROMOTION</span>
          </div>
        
        </div>
      </div>
    </section>
  );
}
